import { makeAutoObservable } from "mobx";

export class AppStore {
    userInfo = {};

    constructor() {
        makeAutoObservable(this);
    }
}

export const appStore = new AppStore();
